// About Page for Portfolio
// About Section ->
//  Dustin Graham
//  Software Engineer
//  Bio
//  Contact Me Button

import React from 'react';

 const AboutPage = () => {
    return (
        <div>
            About Page
        </div>
    )
}

export default AboutPage